import { useRef, useState } from "react";
import { MenuItemAction } from "../../Menu/MenuItem.Dto";
import { useNavigate } from "react-router-dom";
import { MDFeOutput } from "./MDFe.Dto";
import { showToast } from "src/componentes";
import { MDFeBuscarXML } from "src/services/Fiscal.Service";

type MDFeMenuCodeProps = {
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  data: MDFeOutput[];
  onNovoMDFe?: () => void;
  onConsultarNaoEncerrados?: () => void;
};

const MDFeMenuCode = (props: MDFeMenuCodeProps) => {
  const navigate = useNavigate();
  const dataRef = useRef<MDFeOutput[]>(props.data);
  dataRef.current = props.data;

  const onNovoMDFeRef = useRef(props.onNovoMDFe);
  onNovoMDFeRef.current = props.onNovoMDFe;

  const onConsultarNaoEncerradosRef = useRef(props.onConsultarNaoEncerrados);
  onConsultarNaoEncerradosRef.current = props.onConsultarNaoEncerrados;

  const onDownloadXml = async () => {
    props.setLoading(true);
    const dataAtual = dataRef.current;
    if (dataAtual.length === 0) {
      showToast({
        message: "Nenhum MDF-e na lista para download",
        title: "Atenção",
        variant: "Warning",
      });
      props.setLoading(false);
      return;
    }
    try {
      const primeiro = dataAtual[0];
      const ultimo = dataAtual[dataAtual.length - 1];
      const ids = dataAtual
        .map((item) => item.id)
        .filter((id): id is number => id !== undefined && id > 0);

      if (ids.length === 0) {
        showToast({
          message: "Nenhum MDF-e válido encontrado",
          title: "Atenção",
          variant: "Warning",
        });
        props.setLoading(false);
        return;
      }

      const nomeArquivo = `MDFe_${primeiro?.numeroMDFe}_${ultimo?.numeroMDFe}`;
      const response = await MDFeBuscarXML(ids, nomeArquivo);
      const blob = new Blob([response.data], { type: "application/zip" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${nomeArquivo}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      showToast({
        message: "Ocorreu erro ao baixar XML",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      props.setLoading(false);
    }
  };

  const menuPrincipal: MenuItemAction[] = [
    {
      id: 1,
      nome: "Novo MDF-e...",
      rota: props.onNovoMDFe ? "" : "/fiscal/mdfe/cadastro",
      sequencia: 1,
      nivel: 1,
      idNivelAnterior: 0,
      action: () => {
        if (onNovoMDFeRef.current) {
          onNovoMDFeRef.current();
        } else {
          navigate("/fiscal/mdfe/cadastro");
        }
      },
    },
    {
      id: 2,
      nome: "Manifestos Não Encerrados...",
      rota: "",
      sequencia: 2,
      nivel: 1,
      idNivelAnterior: 0,
      action: () => {
        if (onConsultarNaoEncerradosRef.current) {
          onConsultarNaoEncerradosRef.current();
        }
      },
    },
    {
      id: 3,
      nome: "Baixar XML",
      rota: "",
      sequencia: 3,
      nivel: 1,
      idNivelAnterior: 0,
      action: onDownloadXml,
    },
  ];

  const [menuItens, setMenuItens] = useState<MenuItemAction[]>(menuPrincipal);

  const handleMenuClick = (item: MenuItemAction) => (e: React.MouseEvent) => {
    if (item.children && item.children.length > 0) {
      e.stopPropagation();
      setMenuItens(item.children);
    } else if (item.action) {
      item.action();
    } else if (item.rota) {
      navigate(item.rota);
    }
  };

  const handleMenuToggleClick = (isOpen: boolean) => {
    if (!isOpen) {
      setMenuItens(menuPrincipal);
    }
  };

  return {
    handleMenuClick,
    handleMenuToggleClick,
    menuItens,
  };
};

export default MDFeMenuCode;
